import type { FormatLocale } from '#layers/base/public';
import { formatPlainDate, resolveTimezone, unixTimestampConverter } from '#layers/base/public';

/** Formats a license expiry (unix SECONDS); undefined when there is no expiry. */
export function formatExpiry(
	expiresAt: number | null | undefined,
	locale: FormatLocale,
	timeZone: string,
): string | undefined {
	if (typeof expiresAt !== 'number' || !Number.isFinite(expiresAt) || expiresAt <= 0) return undefined;

	const date = unixTimestampConverter
		.toPlainDateTime(expiresAt * 1000, resolveTimezone(timeZone))
		?.toPlainDate();

	return formatPlainDate(date, locale, { dateStyle: 'long' });
}
